import { ContractsBenefitsPlansRequestInterface } from '../../../../interfaces/request/contracts/contracts-benefits-plans/contracts-benefits-plans-request-interface';

export class ContractBenefitsPlanRequestModel implements ContractsBenefitsPlansRequestInterface {
  PolicyId: number = -1;
  page: number = 1;
  pageSize: number = 5;

  constructor(init?: Partial<ContractBenefitsPlanRequestModel>) {
    Object.assign(this, init);
  }
}
